const snowVertexShader = /* glsl */ `
precision highp float;

uniform sampler2D uHeightMap;
uniform float uDepth;

varying vec2 vUv;

void main() {
  vUv = uv;

  float deformation = texture2D(uHeightMap, uv).r;

  vec3 displaced = position;
  displaced.z -= deformation * uDepth;

  gl_Position =
    projectionMatrix *
    modelViewMatrix *
    vec4(displaced, 1.0);
}
`;

export default snowVertexShader;
